export default "__VITE_ASSET__D$UFtRGG__"